define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for Enabling Inventory.
     *
     * @class InventoryIntegration
     */
    return IntegrationModel.extend("InventoryIntegration", {}, {
        type: "InventoryTagging"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/InventoryTaggingModel.js